import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import EstimateForm from "./EstimateForm";

interface EstimateModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const EstimateModal: React.FC<EstimateModalProps> = ({ isOpen, onClose }) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [showModal, setShowModal] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShowModal(true); // mount modal
    }
  }, [isOpen]);

  useEffect(() => {
    if (showModal && isOpen && modalRef.current) {
      // OPEN ANIMATION
      gsap.fromTo(
        modalRef.current,
        { x: "100%" },
        { x: "0%", duration: 0.6, ease: "power3.out" }
      );
    }

    if (!isOpen && modalRef.current) {
      // CLOSE ANIMATION
      gsap.to(modalRef.current, {
        x: "100%",
        duration: 0.7,
        ease: "power3.inOut",
        onComplete: () => setShowModal(false),
      });
    }
  }, [isOpen, showModal]);

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-[100] flex">
      {/* Background overlay with fade */}
      <div
        className="absolute inset-0 bg-[#0d1821]/80 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Drawer content */}
      <div
        ref={modalRef}
        className="relative flex items-center justify-center z-10 h-full text-[#0d1821] bg-[#f5f5f5] p-4 w-full sm:w-[40%] ml-auto rounded-l-[90px]"
      >
        <EstimateForm />

        {/* Close button */}
        <button
          className="absolute top-[40px] right-[40px] text-[#0d1821] hover:text-[#00a878] border border-[#0d1821]/50 rounded-full hover:border-[#00a878]"
          onClick={onClose}
        >
          <div className="p-[6px] h-10 w-10 text-xl">✕</div>
        </button>
      </div>
    </div>
  );
};

export default EstimateModal;
